<template>
  <div>
    <form @submit.prevent="submit">
      <div class="form-group">
        <validated-input
          label="Display Name"
          :validate="{ required: true }"
          v-model="vendor.DisplayName" />
        <validated-input
          label="Account Number"
          :validate="{ required: true }"
          v-model="vendor.AcctNum" />
      </div>
      <div class="form-group mt-2">
        <button
          class="btn btn-primary"
          type="submit"
          :disabled="errors.any() || processing">
          <i v-if="processing" class="far fa-spinner-third fa-spin"></i> Save
        </button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  name: 'PurchaseOrderVendorQuickBookSyncCreateCustomer',
  props: {
    order: {
      type: Object,
      required: true
    },
    purchaseOrder: {
      type: Object,
      required: true
    }
  }
};
</script>

<script>
import { createVendor } from '@/api/qb';
import { updateDistSupplier } from '@/api/distsuppliers';
import { parseErrorMessage } from '@/utils/http-common';

export default {
  name: 'PurchaseOrderVendorQuickBookSyncCreateVendor',
  data() {
    return {
      processing: false,
      vendor: {
        DisplayName: null,
        AcctNum: null
      }
    }
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    purchaseOrder: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.populateVendorData();
  },
  methods: {
    populateVendorData() {
      const { name } = this.purchaseOrder.supplier || {};
      this.vendor.DisplayName = name;
    },
    async submit() {
      await this.$validator.validateAll();
      if (this.errors.any()) return;
      try {
        this.processing = true;
        const { Id } = await createVendor(this.vendor);

        const distributorId = this.order.distributorId?._id;
        const supplierId = this.purchaseOrder.supplier?._id;
        const data = { qbVendorId: Id, distributorId };
        await updateDistSupplier(supplierId, data);
        this.$emit('sync', Id);
      } catch (e) {
        const errorMessage = parseErrorMessage(e) || 'Failed Save QB ID';
        this.notificateError(errorMessage);
      } finally {
        this.processing = false;
      }
    }
  }
};
</script>
